import { SizeLabels } from '@/api/types'

interface MediaSize {
  width: number
  height: number
}

const readMediaSize = (file: File): Promise<MediaSize | null> =>
  new Promise((resolve) => {
    const url = URL.createObjectURL(file)
    const done = (size: MediaSize | null) => {
      URL.revokeObjectURL(url)
      resolve(size)
    }

    if (file.type === 'video/mp4') {
      const video = document.createElement('video')
      video.preload = 'metadata'
      video.onloadedmetadata = () =>
        done({ width: video.videoWidth, height: video.videoHeight })
      video.onerror = () => done(null)
      video.src = url
      return
    }

    const image = new Image()
    image.onload = () =>
      done({ width: image.naturalWidth, height: image.naturalHeight })
    image.onerror = () => done(null)
    image.src = url
  })

const bannerSize = (sizeId: number | undefined): MediaSize | null => {
  const label = SizeLabels.find((size) => size.id === sizeId)?.label
  const [width, height] = (label ?? '').split('x').map(Number)
  if (!width || !height) return null

  return { width, height }
}

// Same comparison as the backend, which has the final say: a file this cannot read
// passes here and is judged there
export const bannerRatioError = async (
  file: File,
  sizeId: number | undefined
): Promise<string | null> => {
  const expected = bannerSize(sizeId)
  if (!expected) return null

  const actual = await readMediaSize(file)
  if (!actual) return null
  if (actual.width / actual.height === expected.width / expected.height) {
    return null
  }

  return `${file.name}: must be ${expected.width}x${expected.height} or the same aspect ratio (got ${actual.width}x${actual.height})`
}
